import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppWrapper } from './AppWrapper';
import App from './components/App';

function PriorAuthApp() {
  return (
    <AppWrapper>
      <App />
    </AppWrapper>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<PriorAuthApp />);
